import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from 'vuex-module-decorators';
import store from '@/store';
import { Popup } from '@/store/models';

@Module({ namespaced: true, name: 'popup', store, dynamic: true })
class PopupModule<T> extends VuexModule {
  public popup: Popup | null = null;
  public showPopup: boolean = false;
  public payload: T | null = null;

  @MutationAction
  public async initPopup(popup: Popup) {
    return { popup };
  }

  @MutationAction
  public async setShowPopup(showPopup: boolean) {
    return { showPopup };
  }

  @MutationAction
  public async setPayload(payload: T) {
    return { payload };
  }
}

const popupModule = getModule(PopupModule);
export default popupModule;
